import MinimumCqlScoreWidget from './../MinimumCqlScoreWidget'
import { withProps } from 'recompose'
import {
  getPardotConfig,
  patchPardotConfig,
  setPardotLeadOwnerField,
  getPardotLeadOwnerField,
  getPardotTranscriptField,
  setPardotTranscriptField } from 'app/modules/integrations/api'
import { api } from 'app/modules/pardot/api'
import PardotProspectFieldSelect from './PardotProspectFieldSelect'
import PardotProspectCampaignInput from './PardotProspectCampaignInput'
import { pathOr } from 'ramda'

export const model = [
  {
    type: 'syncProspectsEnabled',
    value: false,
    label: 'Sync prospects from Drift to Pardot',
    description: 'Prospects from Drift will be created or updated in Pardot whenever a conversation closes',
  },
  {
    type: 'shouldOnlySyncQualified',
    value: false,
    label: 'Set a minimum CQL score for synced contacts and conversations',
    description: 'Unchecked, Drift will sync all contacts and conversations to Pardot except those that have been disqualified.',
    children: {
      autoExpand: true,
      label: 'Minimum CQL score',
      description: 'Drift will only sync conversations that have the selected CQL score or higher.',

      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        integrationName: 'pardot',
        setMinimumCQLScore: (data) => {
          return patchPardotConfig({ "minimumCQLScore": data.score })
        },
        getMinimumCQLScore: () => {
          return getPardotConfig()
        }
      })(MinimumCqlScoreWidget),
      items: []
    }
  },
  {
    type: 'shouldSetLeadOwner',
    value: false,
    label: 'Assign a Lead Owner in Pardot',
    description: "For every new prospect that Drift creates, we'll assign a Lead Owner email based on who books a meeting, who was routed into the conversation, or who closes the conversation (in that order!).",
    openAdvancedSettingsOnEnable: true,
    children: {
      label: 'Lead Owner field',
      description: "Which Pardot field should Drift use? Note that this will overwrite the chosen field’s existing value in Pardot.",
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        getSelectedField: getPardotLeadOwnerField,
        setSelectedField: setPardotLeadOwnerField,
        fetchFields: api.fetchPardotFields,
        isEnabled: true,
      })(PardotProspectFieldSelect),
      items: []
    }
  },
  {
    type: 'syncConversationTranscriptsEnabled',
    value: false,
    label: 'Sync conversation transcripts from Drift to Pardot',
    description: "A conversation transcript will be pushed to the selected field whenever a conversation closes. We recommend using a custom field of type textarea in Pardot.",
    openAdvancedSettingsOnEnable: true,
    children: {
      label: 'Conversation Transcript Field',
      description: "Which Pardot field should Drift use? Note that this will overwrite the chosen field's existing value in Pardot.",
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        getSelectedField: getPardotTranscriptField,
        setSelectedField: setPardotTranscriptField,
        fetchFields: api.fetchPardotFields,
        isEnabled: true,
      })(PardotProspectFieldSelect),
      items: []
    }
  },
  {
    type: 'shouldSetProspectCampaign',
    value: false,
    label: 'Assign prospects created by Drift to a Pardot campaign',
    description: "For every new prospect that Drift creates, we'll assign that prospect to a desired Pardot campaign",
    openAdvancedSettingsOnEnable: true,
    children: {
      label: 'Default prospect campaign field',
      description: "Which Pardot campaign should Drift use? Note that this will only be set for new prospects into Pardot. You can also search for the exact Campaign name below.",
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        setProspectCampaignField: (prospectCampaign) => patchPardotConfig({ prospectCampaign }),
        getPardotConfig,
        fetchCampaigns: api.fetchPardotProspectCampaigns,
        searchCampaigns: api.searchPardotProspectCampaigns,
        isEnabled: true,
      })(PardotProspectCampaignInput),
      items: []
    }
  },
  {
    type: 'cookieIdentificationEnabled',
    value: false,
    label: 'Identify Drift visitors with the Pardot cookie',
    description: `If someone was already identified by Pardot, Drift will automatically recognize them as a known contact. We'll only check Pardot if the visitor has a Pardot cookie set.`,
  }
]

export const hydrateModel = toggles => {
  return [...model].map(topLevel => {
    const updatedToggle = Object.assign({}, topLevel)
    updatedToggle.value = toggles[topLevel.type]
    return updatedToggle
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/PardotConfig/model.js